export default function Dialog(theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        root: {
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.25)'
          },
          '& .MuiDialog-paper': {
            backgroundColor: theme.palette.background.paper,
            opacity: 1,
            backdropFilter: 'none',
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[8],
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 2),
          fontWeight: 600,
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          // Restore top padding when content follows DialogTitle (MUI defaults this to 0)
          '.MuiDialogTitle-root + &': {
            paddingTop: theme.spacing(3),
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2, 3, 3),
          borderTop: `1px solid ${theme.palette.divider}`,
          gap: theme.spacing(1),
        },
      },
    },
  };
}

